const BASE = {
  EVENTS: {
    APP: {
      INIT: 'app.init',
      ERROR: 'app.error',
      READY: 'app.ready'
    },
    TOAST_NOTIFICATION: {
      SHOW: 'toast.show'
    },
    NETWORK: {
      REQUEST: 'network.request',
      REQUEST_START: 'network.request.start',
      REQUEST_END: 'network.request.end',
      REQUEST_ERROR: 'network.request.error',
      RESPONSE: 'network.response'
    }
  },
  ENDPOINTS: {
    CORE: {
      BASE: 'https://api.kingrecharges.com'
    }
  }
};

class ConstantsManager {
  constructor(baseConstants) {
    this.constants = { ...baseConstants };
  }

  loadFeatureModules() {
    return import.meta.glob('/src/app/features/**/constants.js', {
      eager: true
    });
  }

  mergeModule(module) {
    for (const key in module) {
      if (
        this.constants[key] &&
        typeof this.constants[key] === 'object' &&
        typeof module[key] === 'object' &&
        !Array.isArray(this.constants[key]) &&
        !Array.isArray(module[key])
      ) {
        this.constants[key] = { ...this.constants[key], ...module[key] };
      } else {
        this.constants[key] = module[key];
      }
    }
  }

  mergeAllFeatureModules() {
    const featureModules = this.loadFeatureModules();
    for (const mod of Object.values(featureModules)) {
      this.mergeModule(mod);
    }
  }

  get all() {
    return this.constants;
  }

  get CORE() {
    return this.constants.CORE;
  }
  get EVENTS() {
    return this.constants.EVENTS;
  }
  get ENDPOINTS() {
    return this.constants.ENDPOINTS;
  }
}

const constantsManager = new ConstantsManager(BASE);
constantsManager.mergeAllFeatureModules();

if (typeof window !== 'undefined') {
  window.$constants = constantsManager.all;
  window.CORE = constantsManager.CORE;
  window.EVENTS = constantsManager.EVENTS;
  window.ENDPOINTS = constantsManager.ENDPOINTS;
}

export const CORE = constantsManager.CORE;
export const EVENTS = constantsManager.EVENTS;
export const ENDPOINTS = constantsManager.ENDPOINTS;
export default constantsManager.all;
